import {
  cssVar,
  theme as chakraDefaultTheme,
  defineStyle,
  defineStyleConfig,
} from '@chakra-ui/react';

import type { SkeletonStyleConfig } from './types';

const {
  components: { Skeleton: chakraDefaultSkeletonTheme },
} = chakraDefaultTheme;

const $startColor = cssVar('skeleton-start-color');
const $endColor = cssVar('skeleton-end-color');

const baseStyle = defineStyle({
  ...chakraDefaultSkeletonTheme?.baseStyle,
  [$startColor.variable]: 'colors.separator.border',
  [$endColor.variable]: 'colors.separator.divider',
} satisfies SkeletonStyleConfig['baseStyle']);

const customStyleConfig = {
  baseStyle,
} satisfies SkeletonStyleConfig;

export const SKELETON_STYLE_CONFIG = defineStyleConfig({
  ...chakraDefaultSkeletonTheme,
  ...customStyleConfig,
}) as SkeletonStyleConfig;
